import generateQueryParams from '@/utils/generateQueryParams';
import axiosInstance from '@/plugins/api/axiosInstance';

export default function invoices() {
    return {
        addDocument,
        addImage,
        create,
        get,
        index,
        processAlert,
        remove,
        removeDocument,
        removeImage,
        update,
        printLabel
    };

    function index(options = {}) {
        const defaultValues = {
            limit: 25,
            page: 1,
            pattern: null
        };
        const params = generateQueryParams(options, defaultValues);
        return axiosInstance.get(`alert/search${params}`);
    }

    function get(alertId) {
        return axiosInstance.get(`alert/get?id=${alertId}`);
    }

    function create(payload) {
        const formData = new FormData();

        Object.entries(payload).forEach(([key, value]) => {
            formData.append(key, value);
        });

        return axiosInstance.post('alert/create', formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
    }

    function update(payload) {
        const formData = new FormData();

        Object.entries(payload).forEach(([key, value]) => {
            formData.append(key, value);
        });

        return axiosInstance.post('alert/update', formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
    }

    function remove(alertId) {
        return axiosInstance.delete(`alert/delete`, {
            data: { ids: [alertId] }
        });
    }

    function addImage(image, id) {
        const formData = new FormData();
        formData.append('image', image);
        formData.append('id', id);

        return axiosInstance.post('alert/upload-image', formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
    }

    function removeImage(id) {
        return axiosInstance.delete(`alert/delete-image`, {
            data: {
                id: id
            }
        });
    }

    function addDocument(alertId, document) {
        const formData = new FormData();
        formData.append('id', alertId);
        formData.append('document', document);
        return axiosInstance.post('alert/upload-document', formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
    }

    function removeDocument(id) {
        return axiosInstance.delete('alert/delete-document', {
            data: {
                id: id
            }
        });
    }

    function processAlert(alertId, format) {
        return axiosInstance.get(`alert/process`, {
            params: {
                id: alertId,
                format: format
            }
        });
    }

    function printLabel(id) {
        return axiosInstance.get(`alert/label?id=${id}`, {
            timeout: 60000,
            responseType: 'arraybuffer',
            headers: {
                Accept: 'application/pdf',
                'Content-Type': 'application/json'
            }
        });
    }
}
